/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosError } from "axios";

import useApi from "../api";
import { IApiResponse } from "../interfaces/IApiResponse";
import { useFormatMessage } from "../../utils/useFormatMessage";
import { IUser } from "./interfaces/IUser";
import { IUserPhotoUpdate } from "./interfaces/IUserPhotoUpdate";
import { IProfile } from "../user/interfaces/IProfile";
import { IUserUpdatePassword } from "./interfaces/IUserUpdatePassword";
import { IUserCreateAndUpdate } from "./interfaces/IUserCreateAndUpdate";

export const useUserService = () => {
  const api = useApi();
  const { errorMessage } = useFormatMessage();

  async function getUsers(): Promise<IApiResponse<IUser[] | any>> {
    try {
      const response = await api.get(`/User/getAll`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function getUserById(publicId: string): Promise<IApiResponse<IUser | any>> {
    try {
      const response = await api.get(`/User/GetById/${publicId}`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  async function createUser(
    model: IUserCreateAndUpdate
  ): Promise<IApiResponse<IUser[] | any>> {
    try {
      const response = await api.post(`/User/Create`, model);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function updateUser(
    model: IUserCreateAndUpdate
  ): Promise<IApiResponse<IUser[] | any>> {
    try {
      const response = await api.post(`/User/Update`, model);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }
  async function deleteUser(
    publicId: string
  ): Promise<IApiResponse<IUser[] | any>> {
    try {
      const response = await api.post(`/User/Inactivate/${publicId}`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  //Não utilizado
  async function getUserProfiles(): Promise<IApiResponse<IProfile[] | any>> {
    try {
      const response = await api.get(`/User/Profiles`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function getUsersTrash(): Promise<IApiResponse<IUser[] | any>> {
    try {
      const response = await api.get(`/User/Trash`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function restoreUserTrash(
    id: any
  ): Promise<IApiResponse<IUser[] | any>> {
    try {
      const response = await api.put(`/User/RestoreTrash/${id}`);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function updateUserPhoto(
    model: IUserPhotoUpdate
  ): Promise<IApiResponse<any>> {
    try {
      const response = await api.put(`/User/Photo`, model);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function updateUserPassoword(
    model: IUserUpdatePassword
  ): Promise<IApiResponse<any>> {
    try {
      const response = await api.put(`/User/Password`, model);
      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function getUserProfilesTPClient(): Promise<any> {
    try {
       const response = await api.get(`/TPClient/TreeOption/FIES`);
      return { status: 200, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  return {
    getUsers,
    getUserById,
    getUserProfiles,
    getUserProfilesTPClient,
    createUser,
    updateUser,
    deleteUser,
    getUsersTrash,
    restoreUserTrash,
    updateUserPhoto,
    updateUserPassoword,
  };
};
